<template>
	<section class="new-confirmed-events new-layout-container">
		<div class="new-confirmed-events__header">
			<div>
				<div class="new-confirmed-events__mark"></div>
				<h2>{{confirmedEvents.title}}</h2>
				<p>{{homeTranslation.aboveEventCalendarText}}</p>
			</div>
		</div>

		<div v-if="loading" class="new-confirmed-events__state">{{confirmedEvents.loading}}</div>
		<div v-else-if="events.length === 0" class="new-confirmed-events__state">{{confirmedEvents.empty}}</div>
		<div v-else class="new-confirmed-events__grid">
			<event-card v-for="event in events" :key="event.id || event.shortName" :event="event" />
		</div>

		<div ref="trustindex" class="new-confirmed-events__trustindex" :aria-label="confirmedEvents.reviewsLabel"></div>
	</section>
</template>

<script>
import { translate } from '../../assets/translations.js';
import EventCard from './EventCard.vue';

const TRUSTINDEX_SCRIPT_URL = 'https://cdn.trustindex.io/loader.js?d3b8b94714b45171e516896b39e';

export default {
	components: {
		EventCard,
	},
	props: {
		events: {
			type: Array,
			default: () => [],
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		homeTranslation() {
			return translate(this.$store.state.language).home;
		},
		confirmedEvents() {
			return this.homeTranslation.confirmedEvents;
		},
	},
	mounted() {
		this.loadTrustindex();
	},
	beforeDestroy() {
		if (this.$refs.trustindex) this.$refs.trustindex.innerHTML = '';
	},
	methods: {
		loadTrustindex() {
			const trustindex = this.$refs.trustindex;
			if (!trustindex || trustindex.querySelector('script')) return;

			const script = document.createElement('script');
			script.defer = true;
			script.async = true;
			script.src = TRUSTINDEX_SCRIPT_URL;
			trustindex.appendChild(script);
		},
	},
};
</script>

<style scoped lang="scss">
.new-confirmed-events {
	padding: 4.17vw 0 4.98vw;
}

.new-confirmed-events__header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 1.62vw;
	margin-bottom: 2.08vw;
	padding: 0 3.5%;
}

.new-confirmed-events__mark {
	width: 2.55vw;
	height: .23vw;
	margin-bottom: 1.1vw;
	background: #f49a1c;
}

.new-confirmed-events h2 {
	margin: 0 0 .58vw;
	color: #5b5b5b;
	font-size: 2.31vw;
	font-weight: 500;
	line-height: 1.18;
	letter-spacing: 0;
}

.new-confirmed-events p {
	margin: 0;
	color: #555555;
	font-size: 1.27vw;
	font-weight: 400;
	line-height: 1.59;
}

.new-confirmed-events__grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	grid-auto-rows: 1fr;
	column-gap: 2%;
	row-gap: 4.63vw;
}

.new-confirmed-events__state {
	min-height: 180px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #777777;
	font-size: 15px;
}

.new-confirmed-events__trustindex {
	margin-top: 4.17vw;
}

@media (max-width: 1000px) {
	.new-confirmed-events__grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 820px) {
	.new-confirmed-events {
		padding: 3.625rem 0 4.5rem;
	}

	.new-confirmed-events__header {
		flex-direction: column;
		gap: 1.5rem;
		margin-bottom: 1.875rem;
		padding: 0;
	}

	.new-confirmed-events__mark {
		width: 2.25rem;
		height: .1875rem;
		margin-bottom: 1rem;
	}

	.new-confirmed-events h2 {
		margin-bottom: .625rem;
		font-size: 2rem;
	}

	.new-confirmed-events p {
		font-size: 1rem;
		line-height: 1.5;
	}

	.new-confirmed-events__trustindex {
		margin-top: 3rem;
	}
}

@media (max-width: 650px) {
	.new-confirmed-events__grid {
		grid-template-columns: 1fr;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/home/EventCalendar.vue